export const PHONE = '+49 162 6830312';
export const DOMAIN = 'moritz-heusinger.de';
export const OWNER = 'Moritz Heusinger';
export const STREET = 'An den Mühltannen 28';
export const CITY = '97080 Würzburg';
export const EMAILJS_SERVICE_ID = 'service_ajze89g';
export const EMAILJS_TEMPLATE_ID = 'template_06vsyv1';
export const EMAILJS_PUBLIC_KEY= 'vOtYpEpriX4GeEM0W';